import request from '@/utils/request'


export function post(url,data) {
    return request({
      url: `/api/${url}`,
      method: 'post',
      data
    })
  }